import React from 'react'

export default function Card(props) {
  return <div className={'card ' + props.className}>{props.label}</div>
}



// WEBPACK FOOTER //
// ./src/components/Card.js